import {Component, Input, OnInit} from '@angular/core';
import { EventsManager } from "../../events/events.manager";
import { PhonePipe } from '../../pipes/phone.pipe';
import { ErrorBannerComponent } from '../common/error-banner/error-banner-component';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: true,
    imports: [NgIf, ErrorBannerComponent, PhonePipe]
})
export class HeaderComponent implements OnInit {
info:any = {};
isAdminBy:string = '';
hideHeader:boolean = false;

  constructor(public em:EventsManager) { }

  ngOnInit(): void {
    //console.log('office: ', this.office);
    this.em.contactInfoUpdated.subscribe(
      (info:any) => {
        this.info = this.em.contactInfo;
      }
    )

    this.em.isAdminByUpdated.subscribe(
      (isAdminBy:string) => {
        this.isAdminBy = isAdminBy;
      }
    )

    this.hideHeader = this.em.hideTopHeader;

    this.em.hideHeader.subscribe(
      (hideHeader:boolean) => {
        this.hideHeader = hideHeader;
      }
    )
  }

}
